// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"45":"f6f01af0","49":"496c0a75","130":"c263a66a","147":"93ab4fcc","161":"ab853121","188":"309c9464","287":"ff5edad4","518":"1c3e64f3","543":"1612528b","565":"0d75f93d","607":"ffcc1123","675":"353ad6ec","731":"0c5beee2","745":"5bd5bd3d","968":"5414b636","974":"5dfe68ed"}[chunkId] + ".js";
};